import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Container = styled.div`
  background-color: ${COLOR.ALICE_BLUE};
  padding: 14px 16px 6px;
  display: flex;
  gap: 12px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 0 8px 0;
`;

export const Title = styled.span`
  font-weight: 600;
  color: ${COLOR.EAGLE_GREEN};
`;

export const Subtitle = styled.span`
  font-weight: 400;
  color: ${COLOR.EAGLE_GREEN};
`;
